import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Transcript from 'Components/UI/Transcript';

const styles = theme => ({
  container: {},
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
  },
});

const TranscriptView = ({
  className,
  classes,
}) => {
  return (
    <Transcript
      classes={{
        root: classNames(classes.root, className),
      }}
    />
  );
};

TranscriptView.defaultProps = {
  className: '',
};

TranscriptView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TranscriptView);
